import { createStore } from 'owa-satcheljs';
import type { AccountKey } from 'owa-client-types';

interface CopilotUpsellStore {
    eligibilityByAccount: Map<AccountKey, boolean>;
    pendingEntitlementByAccount: Set<AccountKey>;
}

export const copilotUpsellStore: () => CopilotUpsellStore = createStore<CopilotUpsellStore>(
    'copilotUpsellStore',
    {
        eligibilityByAccount: new Map<AccountKey, boolean>(),
        pendingEntitlementByAccount: new Set<AccountKey>(),
    }
);
